import collectError from './collectError';
const getAppToken = () => {
    try {
        const token = window.localStorage.getItem('appToken');
        return token ? JSON.parse(token) : {};
    }
    catch (error) {
        collectError(error);
        return {};
    }
};
export default getAppToken;
